import React, { FC } from "react";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Radio from "@mui/material/Radio";
import FormControlLabel from "@mui/material/FormControlLabel";
import { Typography } from "@mui/material";
import { format, formatISO } from "date-fns";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

function createData(
  name: string,
  specialization: string,
  data1: string,
  data2: string,
  scores: number
) {
  return { name, specialization, data1, data2, scores };
}

const rows = [
  createData("Интернатура", "Психиатрия", "01.08.1982", "01.08.1982", 5),
  createData(
    "Общее усовершенстование",
    "Терапия",
    "01.08.1982",
    "01.08.1982",
    5
  ),
  createData(
    "Спициализация",
    "По временной нетрудоспособности",
    "01.08.1982",
    "01.08.1982",
    5
  )
];


const Training: FC = () => {

  return (
    <Box mt={1}>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 400 }} aria-label="caption table">
          <TableHead>
            <TableRow>
              <TableCell>Вид подготовки</TableCell>
              <TableCell align="right">Тематика специализации</TableCell>
              <TableCell align="right">Дата начала</TableCell>
              <TableCell align="right">Дата окончания</TableCell>
              <TableCell align="right">Баллы</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <TableRow key={row.name}>
                <TableCell component="th" scope="row">
                  {row.name}
                </TableCell>
                <TableCell align="right">{row.specialization}</TableCell>
                <TableCell align="right">{row.data1}</TableCell>
                <TableCell align="right">{row.data2}</TableCell>
                <TableCell align="right">{row.scores}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Box display="flex" alignItems="center" mt={1}>
        <TextField
          label="Номер приказа "
          variant="outlined"
          size="small"
          sx={{ width: "300px", mt: 1, mb: 1, mr: 2 }} />
        <Typography mr={1}>Дата направления работника на повышение квалификации</Typography>
        <TextField
          value={format(1683886255004, "dd.MM.yyyy")}
          variant="outlined"
          size="small"
          sx={{ width: "200px", mb: 1 }} />
      </Box>
      <Box display="flex" alignItems="center">
        <Typography mr={2}>Период специализации:</Typography>
        <Typography mr={1}>очная часть 1. с</Typography>
        <TextField
          value={format(1683886255004, "dd.MM.yyyy")}
          variant="outlined"
          size="small"
          sx={{ width: "110px", mr: 2 }} 
        />
        <Typography mr={1}>по</Typography>
        <TextField
          value={format(1683886255004, "dd.MM.yyyy")}
          variant="outlined"
          size="small"
          sx={{ width: "110px", mr: 1}} 
        />
        <TextField
          label="дн."
          variant="outlined"
          size="small"
          sx={{ width: "60px", mr: 1}} 
        />
        <TextField
          label="час."
          variant="outlined"
          size="small"
          sx={{ width: "60px", mr: 1}} 
        />
        <Typography mr={1}>2.  c</Typography>
        <TextField
          value={format(1683886255004, "dd.MM.yyyy")}
          variant="outlined"
          size="small"
          sx={{ width: "110px", mr: 1}} 
        />
        <Typography mr={1}>по</Typography>
        <TextField
          value={format(1683886255004, "dd.MM.yyyy")}
          variant="outlined"
          size="small"
          sx={{ width: "110px", mr: 1}} 
        />
        <TextField
          label="дн."
          variant="outlined"
          size="small"
          sx={{ width: "60px", mr: 1}} 
        />
        <TextField
          label="час."
          variant="outlined"
          size="small"
          sx={{ width: "60px", mr: 1}} 
        />
      </Box>
      <Box display="flex" alignItems="center" ml={22.8} mt={1}>
        <Typography mr={1}>заочная часть 1. с</Typography>
        <TextField
          value={format(1683886255004, "dd.MM.yyyy")}
          variant="outlined"
          size="small"
          sx={{ width: "110px", mr: 2 }} 
        />
        <Typography mr={1}>по</Typography>
        <TextField
          value={format(1683886255004, "dd.MM.yyyy")}
          variant="outlined"
          size="small"
          sx={{ width: "110px", mr: 1}} 
        />
        <TextField
          label="дн."
          variant="outlined"
          size="small"
          sx={{ width: "60px", mr: 1}} 
        />
        <TextField
          label="час."
          variant="outlined"
          size="small"
          sx={{ width: "60px", mr: 1}} 
        />
        <Typography mr={1}>2.  c</Typography>
        <TextField
          value={format(1683886255004, "dd.MM.yyyy")}
          variant="outlined"
          size="small"
          sx={{ width: "110px", mr: 1}} 
        />
        <Typography mr={1}>по</Typography>
        <TextField
          value={format(1683886255004, "dd.MM.yyyy")}
          variant="outlined"
          size="small"
          sx={{ width: "110px", mr: 1}} 
        />
        <TextField
          label="дн."
          variant="outlined"
          size="small"
          sx={{ width: "60px", mr: 1}} 
        />
        <TextField
          label="час."
          variant="outlined"
          size="small"
          sx={{ width: "60px", mr: 1}} 
        />
      </Box>
      <Box display="flex" alignItems="center" mt={1}>
        <Typography mr={4.9}>Итого продолжительность обучения</Typography>
        <Typography mr={1}>c</Typography>
        <TextField
          value={format(1683886255004, "dd.MM.yyyy")}
          variant="outlined"
          size="small"
          sx={{ width: "110px", mr: 2 }} 
        />
        <Typography mr={1}>по</Typography>
        <TextField
          value={format(1683886255004, "dd.MM.yyyy")}
          variant="outlined"
          size="small"
          sx={{ width: "110px", mr: 1}} 
        />
        <TextField
          label="дн."
          variant="outlined"
          size="small"
          sx={{ width: "60px", mr: 1}} 
        />
        <TextField
          label="час."
          variant="outlined"
          size="small"
          sx={{ width: "60px", mr: 1}} 
        />
      </Box>
      <Box>
        <Box display="flex" alignItems="center" mt={1}>
          <Typography mr={12.9}>Название УЗ</Typography>
          <TextField
            label=" "
            variant="outlined"
            size="small"
            sx={{ width: "60px", mr: 1}} 
          />
          <TextField
            label=" "
            variant="outlined"
            size="small"
            sx={{ width: "500px", mr: 1}} 
          />
        </Box>
        <Box display="flex" alignItems="center" mt={1}>
          <Typography mr={1}>Тематика специализации</Typography>
          <TextField
            label=" "
            variant="outlined"
            size="small"
            sx={{ width: "60px", mr: 1}} 
          />
          <TextField
            label=" "
            variant="outlined"
            size="small"
            sx={{ width: "500px", mr: 1}} 
          />
        </Box>
        <Box display="flex" alignItems="center" mt={1}>
          <Typography mr={10.4}>Вид подготовки</Typography>
          <TextField
            label=" "
            variant="outlined"
            size="small"
            sx={{ width: "60px", mr: 1}} 
          />
          <TextField
            label=" "
            variant="outlined"
            size="small"
            sx={{ width: "500px", mr: 1}} 
          />
        </Box>
        <Box display="flex" alignItems="center" mt={1}>
          <Typography mr={19.4}>Город</Typography>
          <TextField
            label=" "
            variant="outlined"
            size="small"
            sx={{ width: "60px", mr: 1}} 
          />
          <TextField
            label=" "
            variant="outlined"
            size="small"
            sx={{ width: "500px", mr: 1}} 
          />
        </Box>
        <Box display="flex" alignItems="center" mt={1}>
          <Typography mr={2}>Тип учебного заведения</Typography>
          <TextField
            label=" "
            variant="outlined"
            size="small"
            sx={{ width: "60px", mr: 1}} 
          />
          <TextField
            label=" "
            variant="outlined"
            size="small"
            sx={{ width: "500px", mr: 1}} 
          />
        </Box>
        <Box display="flex" alignItems="center" mt={1}>
          <Typography mr={2}>Цикл</Typography>
          <FormControlLabel
              value="female"
              control={<Radio />}
              label="72ч"
          />
          <FormControlLabel
              value="female"
              control={<Radio />}
              label="144ч"
          />
          <FormControlLabel
              value="female"
              control={<Radio />}
              label="на рабочем месте"
          />
          <TextField
              label="часов"
              variant="outlined"
              size="small"
              sx={{ mr: 1, width: "100px" }}
          />
          <TextField
              label="баллы"
              variant="outlined"
              size="small"
              sx={{ mr: 1, width: "100px" }}
          />
          <Typography mr={2}>Выездной цикл</Typography>
          <FormControlLabel
              label="да"
              value="female"
              control={<Radio />}
          />
          <FormControlLabel
              label="нет"
              value="female"
              control={<Radio />}
          />
        </Box>
        <Box display="flex" alignItems="center" mt={1}>
          <Typography mr={9.5}>Название цикла</Typography>
          <TextField
              label=""
              variant="outlined"
              size="small"
              sx={{ mr: 1, width: "800px" }}
          />
        </Box>
        <Box display="flex" alignItems="center" mt={1}>
          <TextField
            label="Номер документа"
            variant="outlined"
            size="small"
            sx={{ width: "300px", mr: 1}} 
          />
          <TextField
            label="Дата выдачи документа"
            value={format(1683886255004, "dd.MM.yyyy")}
            variant="outlined"
            size="small"
            sx={{ width: "300px", mr: 1}} 
          />
        </Box>
      </Box>
    </Box>
  );
};

export default Training;